<template>
  <div id="app">
  <Toasts />

  <router-view/>
  </div>
</template>

<script>
import Toasts from '@/components/Toasts'

export default {
  components: {
    Toasts
  }
}
</script>
